<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.gerenteRegional.labels.titulo")',
        :voltarPara='{ route: "GerentesRegionais" }'
    )
    .formulario-gerente-regional
        h3.formulario-gerente-regional__titulo {{ $t('mensagens.gerenteRegional.labels.dadosCadastrais') }}
        .formulario-gerente-regional__card
            .select-field
                label.select-field__label {{ $t('mensagens.gerenteRegional.labels.regional') }}
                el-select.select-field__input(
                    :loading='carregandoRegionais',
                    :placeholder='$t("mensagens.comuns.selecione")',
                    v-model='gerenteRegional.idRegional',
                    clearable,
                    filterable
                )
                    el-option(
                        v-for='({ nome, id }, index) in regionais',
                        :key='`regional-${id}-${index}`',
                        :label='nome',
                        :value='id'
                    )

            .input-field
                label.input-field__label.obrigatorio {{ $t('mensagens.gerenteRegional.labels.idBunge') }}
                input.input-field__input(
                    :placeholder='$t("mensagens.gerenteRegional.labels.descricaoId")',
                    v-model='gerenteRegional.idBunge'
                )
            .input-field
                label.input-field__label.obrigatorio {{ $t('mensagens.gerenteRegional.labels.nome') }}
                input.input-field__input(
                    :placeholder='$t("mensagens.gerenteRegional.labels.descricao")',
                    v-model='gerenteRegional.nome'
                )
        h3.formulario-gerente-regional__titulo {{ $t('mensagens.gerenteRegional.labels.dadosVinculados') }}
        .formulario-gerente-regional__card.handler
            FormularioHandler(:titulo='tituloGerenteComercial()')
                MultiselectTable(
                    tableId='gerentes-comerciais-table',
                    :label='formatarGerenteComercial()',
                    v-model='idsGerentesComerciais',
                    :options='gerentesComerciais',
                    :loading='carrengandoGerentesComerciais',
                    :buttonAddLabel='$t("mensagens.gerenteRegional.labels.adicionarGerenteComercial")',
                    :buttonRouteLabel='$t("mensagens.gerenteRegional.labels.criarGerenteComercial")',
                    routeName='GerentesComerciaisCadastro'
                )
        .formulario-gerente-regional__card.handler
            FormularioHandler(:titulo='tituloGerenteTerritorial()')
                MultiselectTable(
                    tableId='gerentes-territoriais-table',
                    :label='formatarGerenteTerritorial()',
                    v-model='idsGerentesTerritoriais',
                    :options='gerentesTerritoriais',
                    :loading='carregandoGerentesTerritoriais',
                    :buttonAddLabel='$t("mensagens.gerenteRegional.labels.adicionarGerenteTerritorial")',
                    :buttonRouteLabel='$t("mensagens.gerenteRegional.labels.criarGerenteTerritorial")',
                    routeName='CadastroGerenteTerritorial'
                )
        .footer
            .footer__btn.voltar(@click='irParaGerentesRegionais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(@click='fluxoSalvarGerenteRegional')
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import services from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'FormularioGerenteRegional',
    props: ['row'],
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        FormularioHandler: () =>
            import('@/components/contratosOriginacao/formulario/Handler'),
        MultiselectTable: () =>
            import(
                '@/components/contratosOriginacao/formulario/MultiselectTable'
            )
    },
    data() {
        return {
            regionais: [],
            gerentesTerritoriais: [],
            gerentesComerciais: [],
            idsGerentesTerritoriais: [],
            idsGerentesComerciais: [],
            gerenteRegional: {
                id: '',
                nome: '',
                idBunge: '',
                idRegional: '',
                idsGerentesComerciais: '',
                idsGerentesTerritoriais: ''
            },
            carregandoRegionais: true,
            carrengandoGerentesComerciais: true,
            carregandoGerentesTerritoriais: true
        };
    },

    mounted() {
        this.carregarListasGerentes();
    },
    methods: {
        async carregarListasGerentes() {
            this.loadingScreen(true);
            await this.buscarGerentesTerritoriais();
            await this.buscarRegionais();
            await this.buscarGerentesComerciais();
            this.preencherCamposEdicao();
            this.loadingScreen(false);
        },
        preencherCamposEdicao() {
            if (this.row?.id) {
                this.gerenteRegional = {
                    id: this.row.id,
                    nome: this.row.nome,
                    idBunge: this.row.idBunge,
                    idRegional: this.row?.idRegional,
                    idsGerentesTerritoriais: this.row?.idsGerentesTerritoriais,
                    idsGerentesComerciais: this.row?.idsGerentesComerciais
                };
                this.idsGerentesTerritoriais =
                    this.row?.idsGerentesTerritoriais || [];
                this.idsGerentesComerciais =
                    this.row?.idsGerentesComerciais || [];
            }
        },
        buscarRegionais() {
            return services.buscarRegionais().then(({ data }) => {
                if (data.length > 0) {
                    this.regionais = data;
                    this.carregandoRegionais = false;
                }
            });
        },
        buscarGerentesTerritoriais() {
            return services.buscarGerentesTerritoriais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesTerritoriais = data;
                    this.carregandoGerentesTerritoriais = false;
                }
            });
        },
        buscarGerentesComerciais() {
            return services.buscarGerentesComerciais().then(({ data }) => {
                if (data.length > 0) {
                    this.carrengandoGerentesComerciais = false;
                    this.gerentesComerciais = data;
                }
            });
        },
        irParaGerentesRegionais() {
            this.$router.push({ name: 'GerentesRegionais' });
        },
        irParaCadastroGerenteTerritorial() {
            this.$router.push({ name: 'CadastroGerenteTerritorial' });
        },
        fluxoSalvarGerenteRegional() {
            const nomeInvalido = !this.gerenteRegional.nome;
            const idBungeInvalido = !this.gerenteRegional.idBunge;
            const mensagemNomeVazio = this.$t(
                'mensagens.gerenteRegional.labels.nomeVazio'
            );
            const mensagemIDBungeVazio = this.$t(
                'mensagens.gerenteRegional.labels.idBungeVazio'
            );

            if (idBungeInvalido) {
                return this.$notify.error(mensagemIDBungeVazio);
            }
            if (nomeInvalido) {
                return this.$notify.error(mensagemNomeVazio);
            }
            if (this.row?.id) {
                this.editarGerenteRegional();
            } else {
                this.cadastrarGerenteRegional();
            }
        },
        cadastrarGerenteRegional() {
            const mensagemSucesso = this.$t(
                'mensagens.gerenteRegional.labels.registroCadastrado'
            );
            let params = {
                nome: this.gerenteRegional.nome,
                idBunge: this.gerenteRegional.idBunge,
                idRegional: this.gerenteRegional.idRegional
            };

            if (this.idsGerentesTerritoriais.length > 0) {
                params.idsGerentesTerritoriais = this.idsGerentesTerritoriais;
            }
            if (this.idsGerentesComerciais.length > 0) {
                params.idsGerentesComerciais = this.idsGerentesComerciais;
            }
            return services.cadastrarGerenteRegional(params).then(() => {
                this.$notify.success(mensagemSucesso);
                this.irParaGerentesRegionais();
            });
        },
        editarGerenteRegional() {
            const mensagemSucesso = this.$t(
                'mensagens.gerenteRegional.labels.registroEditado'
            );
            let params = {
                id: this.gerenteRegional.id,
                nome: this.gerenteRegional.nome,
                idBunge: this.gerenteRegional.idBunge,
                idRegional: this.gerenteRegional.idRegional
            };

            if (this.idsGerentesTerritoriais.length > 0) {
                params.idsGerentesTerritoriais = this.idsGerentesTerritoriais;
            }
            if (this.idsGerentesComerciais.length > 0) {
                params.idsGerentesComerciais = this.idsGerentesComerciais;
            }
            return services.editarGerenteRegional(params).then(() => {
                this.$notify.success(mensagemSucesso);
                this.irParaGerentesRegionais();
            });
        },
        tituloGerenteTerritorial() {
            const gerentesTerritoriais = this.$t(
                'mensagens.gerenteRegional.labels.gerentesTerritoriais'
            );
            const opcional = this.$t(
                'mensagens.gerenteRegional.labels.opcional'
            );

            return `${gerentesTerritoriais} (${opcional})`;
        },
        tituloGerenteComercial() {
            const gerentesTerritoriais = this.$t(
                'mensagens.gerenteRegional.labels.gerentesComerciais'
            );
            const opcional = this.$t(
                'mensagens.gerenteRegional.labels.opcional'
            );

            return `${gerentesTerritoriais} (${opcional})`;
        },
        formatarGerenteTerritorial() {
            return this.idsGerentesTerritoriais.length > 1
                ? this.$t(
                      'mensagens.gerenteRegional.labels.gerentesTerritoriais'
                  )
                : this.$t(
                      'mensagens.gerenteRegional.labels.gerenteTerritorial'
                  );
        },
        formatarGerenteComercial() {
            return this.idsGerentesTerritoriais.length > 1
                ? this.$t('mensagens.gerenteRegional.labels.gerentesComerciais')
                : this.$t('mensagens.gerenteRegional.labels.gerenteComercial');
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss">
.formulario-gerente-regional {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
        &.handler {
            padding: 0;
        }
    }
    .select-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;
        &__label {
            color: $primary;
            font-weight: bold;
        }
        &__input {
            height: 40px;
            border-radius: $default-border-radius;
            outline: 0;
            & input {
                color: var(--primary-font-color) !important;
                &:disabled {
                    color: #545454 !important;
                }
            }
        }
    }
    .input-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;
        &__label {
            color: $primary;
            font-weight: bold;
        }
        &__input {
            height: 40px;
            width: 100%;
            border-radius: $default-border-radius;
            border: 1px solid $default-border-color;
            outline: 0;
            padding: 0 15px;
        }
    }
    .obrigatorio::after {
        content: '* ';
        color: red;
        margin-left: 3px;
    }
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
